/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {registerProps as Éµb} from './tab-pane/tab-pane.props';
export {registerProps as Éµa} from './tabs.props';